import React from 'react';
import { ThemeSettings } from '../components/ThemeSettings';

export default function Appearance() {
  return (
    <div className="page-container" data-testid="appearance-page">
      <ThemeSettings />
    </div>
  );
}
